module.exports = __webpack_public_path__ + "static/media/powerNationLogo.d4978b0c.png";